import React, { useEffect, useState } from 'react'
import s from './SignIn.module.scss'
import * as Yup from 'yup';
import { ReactComponent as Google } from '../../assets/google.svg';
import { FirebaseClient } from "../../FirebaseClient/FirebaseClient";
import { Formik, Field, Form } from 'formik';
import { NavLink, useNavigate } from 'react-router-dom'
import invis from '../../assets/SignUp/invisible.png'
import vis from '../../assets/SignUp/visible.png'
import { useDispatch, useSelector } from 'react-redux';
import { setAuthStatus } from "../../store/authSlice"
import { loginUser, resetAuthError, googleLoginHelper, checkUser, createUser} from '../../store/authSlice';
import { useTranslation } from 'react-i18next';
import { domain } from '../../store/authSlice.js';

export const SignIn = () => {
    const serv_url = domain + 'accounts/password-reset-iac/';
    
    const dispatch = useDispatch()
    const { statusLogin, isAuth, error } = useSelector(state => state.auth)
    const [passVis, setPassVis] = useState(false)

    const { t } = useTranslation()
    const firebase = new FirebaseClient()
    const navigate = useNavigate()
    const passType = passVis ? 'text' : 'password'
    const passIcon = passVis ? vis : invis
    const initialValues = {
        email: '',
        password: ''
    }
    const validationSchema = Yup.object().shape({
        email: Yup.string().required(t('fieldIsRequired')).email(t('invalidEmail')),
        password: Yup.string()
            .required(t('fieldIsRequired'))
            .min(8, t('minSymbols'))
            .max(100, t('maxSymbols'))
    });
    const handleSubmit = async (values) => {
        dispatch(loginUser(values))
    }

    useEffect(() => {
        dispatch(resetAuthError())
    }, [dispatch])

    useEffect(() => {
        if (isAuth) {
            navigate('/userrecognition')
        }
    }, [isAuth, navigate])

    const submitWithGoogle = async () => {
        const user = await firebase.signInWithGoogle()

        if (user !== undefined) {
            var myUser = {
                "user":{
                    "account": [], 
                    "email": user.email, 
                    "is_staff": "false"
                },
                "token": {
                    "access": user.stsTokenManager.accessToken,
                    "refresh": user.stsTokenManager.refreshToken,
                }
            };

            dispatch(setAuthStatus(myUser));
            dispatch(resetAuthError(null));
            dispatch(googleLoginHelper(myUser));
            
            try {
                var password = Math.random().toString(36);
                var values = {'email':user.email, 'password':password}
                dispatch(createUser(values))
            } catch (error) {
                console.log(error)
            }
            // if (dispatch(checkUser(values))){
            //     var password = Math.random().toString(36);
            //     var email = user.email;
            //     var values = { "email": email, "password": password };
            //     console.log(values);
            //     // call the function to create new user 
            //     dispatch(createUser(values));
            // }
        }
    }

    return (
        <div className={s.wrapper}>
            <div>
                <div className={s.container}>

                    <div className={`${s.content} ${statusLogin === 'loading' ? s.animate : ''}`}>
                        <div className={s.birds}></div>
                        <div className={s.formSignIn}>
                            <div className={s.formTittle}>{t('signIn')}</div>
                            <div>
                                <Formik
                                    initialValues={initialValues}
                                    validationSchema={validationSchema}
                                    onSubmit={(values) => {
                                        handleSubmit(values);
                                    }}>
                                    {({ touched, errors }) => (
                                        <Form className={s.form}>
                                            <label htmlFor="email">
                                                {t('signEmail')}
                                            </label>
                                            <div className={s.inputField}>
                                                <Field
                                                    name="email"
                                                    type="text" />
                                            </div>
                                            {errors.email && touched.email ?
                                                <>
                                                    <div className={s.redLine}></div>
                                                    <div className={s.error}>{errors.email}</div>
                                                </>
                                                : null}
                                            <label htmlFor="password">
                                                {t('signPassword')}
                                            </label>
                                            <div className={s.inputField}>
                                                <Field
                                                    name="password"
                                                    type={passType}
                                                /> <i onClick={() => setPassVis(!passVis)}>
                                                    <img className={s.vis} src={passIcon} alt="" /></i>
                                            </div>
                                            {errors.password && touched.password ?
                                                <>
                                                    <div className={s.redLine}></div>
                                                    <div className={s.error}>{errors.password}</div>
                                                </>
                                                : null}
                                                {error ? <div style={{color: 'red'}}>{t('invalidMailPass')}</div> : null}
                                            <button disabled={statusLogin === 'loading' ? true : false} className={s.signBtn} type="submit">
                                                {t('signIn')}
                                            </button>
                                        </Form>
                                    )}
                                </Formik>
                            </div>
                            <div className={s.links}>
                                <a href={serv_url} target="_blank" rel="noopener noreferrer">
                                    {t('forgotYourPassword')}
                                </a>
                                <NavLink to='/signup'>
                                    {t('signUp')}
                                </NavLink>
                            </div>
                            <div onClick={() => submitWithGoogle()} className={s.google_button}>
                                <Google />
                                <span>{t('loginWithGoogle')}</span>
                            </div>

                        </div>
                    </div>
                </div>
                <div className={s.upperCloud}></div>
                <div className={s.uuderCloud}></div>
            </div>

        </div>

    )
}